/* globals GOOGLE_API_KEY: true */
import React, { createContext, use } from 'react';

const KeysContext = createContext({
    googleApiKey: null,
});

export const useKeysContext = () => use(KeysContext);

export const useKeys = () => {
    const context = useKeysContext();
    if (context === undefined) {
        throw new Error('useKeys must be used within a KeysProvider');
    }
    return context;
};

export const KeysProvider = ({
    children = null,
    keys = null,
}: {
    children: React.ReactNode;
    keys: object | null;
}) => <KeysContext value={keys}>{children}</KeysContext>;

export default KeysContext;
